module.exports = __webpack_public_path__ + "static/media/cblogo.63747fac.png";